// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__183Xr","productName":"Table_productName__27SDX"};